import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Exercice } from '../../model/exercice.model';
import { ExerciceService } from '../../service/exercice.service';
import { ExerciceSheet } from '../../model/exerciceSheet.model';

@Component({
  selector: 'app-sheet-practice',
  templateUrl: './sheet-practice.component.html',
  styleUrls: ['./sheet-practice.component.scss']
})
export class SheetPracticeComponent implements OnInit {
  @Input() sheet: ExerciceSheet;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private exerciceService: ExerciceService
  ) { }

  ngOnInit() {
  }

  goToExercice(difficulty: string): void {
    this.exerciceService.getRandomNotValidatedExercice({ difficulty: difficulty, sheet_id: this.sheet.id, language_id: this.sheet.language.id }).subscribe((exercice: Exercice) => {
      this.router.navigate(['./exercices/' + [exercice.id]], { relativeTo: this.route });
    })
  }

}
